import { render } from "./FooterSE.vue?vue&type=template&id=49e52e3a&scoped=true"
import script from "./FooterSE.vue?vue&type=script&lang=js"
export * from "./FooterSE.vue?vue&type=script&lang=js"

import "./FooterSE.vue?vue&type=style&index=0&id=49e52e3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e52e3a"]])

export default __exports__